import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=4efe549a&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=4efe549a&lang=css&scoped=true&"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=4efe549a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe549a",
  null
  
)

export default component.exports